import { FC } from 'react';

import { Rect, Svg, type SvgProps } from './svg';

export const RoundedSquare: FC<SvgProps> = (props) => (
	<Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
		<Rect x={6} y={6} width={12} height={12} rx={4} fill="currentColor" />
	</Svg>
);
